import { Component, Inject } from "@angular/core";
import { DOCUMENT, Location } from "@angular/common";
import { Platform, ModalController } from "@ionic/angular";
import { SplashScreen } from "@capacitor/splash-screen";
import { StatusBar, Style } from "@capacitor/status-bar";
import { NetworkService, ConnectionStatus } from "./services/network.service";
import { OfflineManagerService } from "./services/offline-manager.service";
import { AuthenticationService } from "./authentication/authentication.service";
import { Router, ActivatedRoute } from "@angular/router";
import { Global } from "../global";
import { ModalPage } from "src/app/modals/modal/modal.page";
import { map } from "rxjs/operators";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { AppService } from "src/app/app.service";
import { FileService } from "./services/file.service";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  providers: [Global],
})
export class AppComponent {
  returnUrl: string;
  user: any;
  constructor(
    private platform: Platform,
    //private splashScreen: SplashScreen,
    private route: ActivatedRoute,
    public globals: Global,
    private authenticationService: AuthenticationService,
    private router: Router,
    private location: Location,
    public modalController: ModalController,
    private networkService: NetworkService,
    private offlineManager: OfflineManagerService,
    private http: HttpClient,
    private appservice: AppService,
    private fileService: FileService,
    @Inject(DOCUMENT) private document: any
  ) {
    this.initializeApp();
    SplashScreen.hide();
  }

  private staticDestinations: string[] = [
    "/licenseFinalization",
    "/login",
    "/loginRegistration",
    "/publishedLessons",
    "/userRegistration",
  ];

  async onThumbnailClick(
    event: any,
    key: any,
    Content_GUID: any,
    modalHeading: any
  ) {
    var paramObject = {
      modalType: "contentViewer",
      modalBodyText: "",
      modalHeaderText: modalHeading,
      Content_GUID: Content_GUID,
    };

    const modal = await this.modalController.create({
      component: ModalPage,
      componentProps: {
        paramObject: paramObject,
      },
      cssClass: "modal-fullscreen",
    });

    modal.onDidDismiss().then((dataReturned) => {
      if (dataReturned !== null) {
      }
    });
    return await modal.present();
  }

  redirectToLogin() {
    //to test we will add the XRS app to a temporary webapp called 'test'. So we check if the url says anything about test
    //if it doesn't then we can redirect to /login etc, otherwise we stay on the stsxrs.co.za/test app
    // var href = document.location.href;
    // if (href.includes("test") || href.includes("update")) {
    //   this.router.navigateByUrl(href + "login");
    //   alert("Testing environment");
    // } else this.router.navigateByUrl("/login");

    this.router.navigateByUrl("/login");
  }

  initializeApp() {
    //make sure we jump to the login screen
    
    this.redirectToLogin();

    this.returnUrl = this.location.path();
    this.authenticationService.returnUrl = this.returnUrl;

    this.platform.ready().then(() => {
      StatusBar.setStyle({ style: Style.Dark });

      this.authenticationService.authenticationState.subscribe((state) => {
        if (state) {
          if (this.returnUrl != "") {
            if (this.staticDestinations.indexOf(this.returnUrl) > -1) {
              this.router.navigateByUrl(this.returnUrl);
            } else {
              const clientNameTest = this.returnUrl.replace("/", "");
              const formData: FormData = new FormData();
              formData.append("ClientName", clientNameTest);
              this.appservice.GetClientLanding(formData).subscribe((res) => {
                try {
                  var objClientLanding = JSON.parse(res.toString());
                  this.globals.landingObj = objClientLanding;
                  this.router.navigateByUrl("/clientLanding");
                } catch (e) {
                  if (!this.globals.XRSUser) {
                    this.user = this.authenticationService.user;
                    const userObj = JSON.parse(this.user.User.toString());
                    this.globals.XRSUser = userObj;
                  }
                  this.router.navigateByUrl(this.returnUrl);
                }
              });
            }
          } else {
            if (!this.globals.XRSUser) {
              this.user = this.authenticationService.user;
              const userObj = JSON.parse(this.user.User.toString());
              this.globals.XRSUser = userObj;
            }
            //this.router.navigateByUrl('/home');
          }
        } else {
          if (this.staticDestinations.indexOf(this.returnUrl) > -1) {
            this.router.navigateByUrl(this.returnUrl);
          } else {
            const clientNameTest = this.returnUrl.replace("/", "");

            if (clientNameTest != "") {
              const formData: FormData = new FormData();
              formData.append("ClientName", clientNameTest);
              this.appservice.GetClientLanding(formData).subscribe((res) => {
                try {
                  var objClientLanding = JSON.parse(res.toString());
                  this.globals.landingObj = objClientLanding;
                  this.router.navigateByUrl("/clientLanding");
                } catch (e) {
                  this.redirectToLogin();
                }
              });
            } else {
              this.redirectToLogin();
            }
          }
        }
      });
    });
  }
}
